/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable import/max-dependencies */
import React from 'react'

import { ShowIfDesktop, ShowIfNotDesktop } from '@usap/uicomponents'
import { CartSummaryBanner } from '@usap/widgets/src/components/CarpartsMembership'
import Items from '../Items'
import Summary from '../Summary'
import ShippingUpdate from '../Notification/ShippingUpdate'
import { Container, TrustBannerWrapper } from './DetailsWmo.css'
import { useMembershipStorage } from '../../../../hooks/useMembershipStorage'
import GTM from '../../../../helpers/GTM'
import useMembershipElementShow from '../../../../hooks/useMembershipElementShow'
import { useStaticProps } from '../../../../contexts/staticProps.context'
import TrustBanner from '../../../CustomerTestimonials/TrustBanner'
import { CarpartsCreditCardBadge } from '../../../CarpartsCreditCard/CarpartsCreditCardBadge'
import { useCarpartsCreditCardEnabled } from '../../../../hooks/useCarpartsCreditCardEnabled'

const DetailsWmo = ({
  showShippingUpdate,
  items,
  tooltip,
  lastSkuEta,
  data,
  showLoader,
}) => {
  const isMembershipEnabled = useMembershipElementShow()
  const { membershipStorage } = useMembershipStorage()
  const isCarpartsCreditCardEnabled = useCarpartsCreditCardEnabled()
  const staticProps = useStaticProps()
  const cartSummaryBannerProps = staticProps?.membershipProps?.cartSummaryBanner
  const hasActiveMembership = membershipStorage.membership_status === 'ACTIVE'
  const hasFreeShippingForMembers = Boolean(items?.find(item => item?.inventory?.membershipShippingType === 'Free'))
  const hasFreeShipping = Boolean(items?.find(item => item?.inventory?.shipping?.type === 'Free'))
  const displayMembershipBanner = isMembershipEnabled && Boolean(cartSummaryBannerProps?.display)
  const testimonialWidgetData = staticProps?.testimonialWidget
  const testimonials = testimonialWidgetData?.testimonials || []
  const isTrustBannerEnabled = testimonialWidgetData?.isEnabled || false
  const promoBadgeConfig = staticProps?.promoBadge || {}
  return (
    <Container>
      <div>
        {showShippingUpdate === true && <ShippingUpdate />}
        {isCarpartsCreditCardEnabled
          ? <CarpartsCreditCardBadge />
          : displayMembershipBanner && (
            <ShowIfNotDesktop>
              <CartSummaryBanner
                hasActiveMembership={hasActiveMembership}
                hasFreeShippingForMembers={hasFreeShippingForMembers}
                hasFreeShipping={hasFreeShipping}
                GTM={GTM}
                staticProps={cartSummaryBannerProps}
              />
            </ShowIfNotDesktop>
          )}
        <Items
          data={items}
          tooltip={tooltip}
          lastSkuEta={lastSkuEta}
          promoBadgeConfig={promoBadgeConfig}
          showLoader={showLoader}
          zipCode={data?.modifiers?.location?.zipcode || ''}
        />
      </div>
      <div>
        {displayMembershipBanner && !isCarpartsCreditCardEnabled && (
          <ShowIfDesktop>
            <CartSummaryBanner
              hasActiveMembership={hasActiveMembership}
              hasFreeShippingForMembers={hasFreeShippingForMembers}
              hasFreeShipping={hasFreeShipping}
              GTM={GTM}
              staticProps={cartSummaryBannerProps}
            />
          </ShowIfDesktop>
        )}
        <Summary data={data} showLoader={showLoader} />
        <TrustBannerWrapper>
          <TrustBanner
            isEnabled={isTrustBannerEnabled}
            testimonials={testimonials}
            dataTestId="cart_testimonial_widget"
          />
        </TrustBannerWrapper>
      </div>
    </Container>
  )
}

export default DetailsWmo
